const TileResolution = {
    Default: 1,
    Standard: 1,
    High: 2
};

Object.freeze(TileResolution);

export default TileResolution;